<template functional>
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
			<path d="M469.333,21.333H42.667C19.135,21.333,0,40.469,0,64v298.667c0,23.531,19.135,42.667,42.667,42.667h149.362
				c-0.46,17.052-3.728,44.306-15.893,57.104c-4.469,4.708-9.604,6.896-16.135,6.896c-5.896,0-10.667,4.771-10.667,10.667
				c0,5.896,4.771,10.667,10.667,10.667h192c5.896,0,10.667-4.771,10.667-10.667c0-5.896-4.771-10.667-10.667-10.667
				c-6.531,0-11.667-2.188-16.135-6.896c-12.165-12.798-15.434-40.052-15.893-57.104h149.362c23.531,0,42.667-19.135,42.667-42.667
				V64C512,40.469,492.865,21.333,469.333,21.333z M197.729,469.333c12.881-19.749,15.374-48.188,15.695-64h85.151
				c0.322,15.813,2.814,44.251,15.695,64H197.729z M490.667,362.667c0,11.76-9.573,21.333-21.333,21.333H42.667
				c-11.76,0-21.333-9.573-21.333-21.333V320h469.333V362.667z M490.667,298.667H21.333V64c0-11.76,9.573-21.333,21.333-21.333
				h426.667c11.76,0,21.333,9.573,21.333,21.333V298.667z"/>
        <circle cx="256" cy="352" r="21.333"/>
        <path d="M320,149.333c23.531,0,42.667-19.135,42.667-42.667S343.531,64,320,64s-42.667,19.135-42.667,42.667
				c0,3.061,0.354,6.036,0.97,8.917l-54.302,27.16C216.174,133.785,204.806,128,192,128c-23.531,0-42.667,19.135-42.667,42.667
				s19.135,42.667,42.667,42.667c12.803,0,24.171-5.781,31.996-14.737l54.307,27.154c-0.616,2.88-0.97,5.855-0.97,8.917
				c0,23.531,19.135,42.667,42.667,42.667s42.667-19.135,42.667-42.667S343.531,192,320,192c-12.806,0-24.176,5.784-32.003,14.743
				l-54.303-27.152c0.617-2.883,0.973-5.859,0.973-8.924c0-3.061-0.354-6.036-0.97-8.917l54.302-27.16
				C295.826,143.548,307.194,149.333,320,149.333z M320,85.333c11.76,0,21.333,9.573,21.333,21.333
				c0,11.76-9.573,21.333-21.333,21.333s-21.333-9.573-21.333-21.333C298.667,94.906,308.24,85.333,320,85.333z M192,192
				c-11.76,0-21.333-9.573-21.333-21.333c0-11.76,9.573-21.333,21.333-21.333s21.333,9.573,21.333,21.333
				C213.333,182.427,203.76,192,192,192z M320,213.333c11.76,0,21.333,9.573,21.333,21.333c0,11.76-9.573,21.333-21.333,21.333
				s-21.333-9.573-21.333-21.333C298.667,222.906,308.24,213.333,320,213.333z"/>
</svg>

</template>

<script>
export default {
    name: "ScreenSharingIcon"
}
</script>

<style scoped>

</style>
